<div [ngClass]="{ 'active-modal': !isRegister, 'register-sucessful': isRegister }">
    <section class="register register-home" *ngIf="!showForm && !isRegister && showButtonStartNow">
        <div class="container">
            <div class="row">
                <div class="col-left">
                    <img src="./assets/img/gennius/register-phone.webp" alt="">
                </div>
                <div class="col-right">
                    <h2>Welcome to</h2>
                    <img class="miles-logo" src="./assets/img/cryptmi/miles-logo.svg" alt="">
                    <p>The latest evolution of loyalty payments <br> —an end-to-end solution that achieves <br> more
                        freedom
                        to cardholders and less <br> hassle for banks.</p>
                    <button (click)="showFormB()">Register now!</button>
                </div>
            </div>
        </div>
    </section>

    <section class="register register--form" *ngIf="showForm && !isRegister">
        <div class="container">

            <div class="modal" *ngIf="showMessageError">
                <!-- <div class="modal" *ngIf="true"> -->
                <div class="content">
                    <div class="icon-close" (click)="closeModalError()"></div>
                    <span>
                        <img src="./assets/img/gennius/icon-alert-register.png" alt="">
                    </span>
                    <p>
                        There was a problem with your registration process.
                    </p>
                </div>
            </div>

            <div class="block-center">
                <h2>Hi, There!</h2>
                <p>Enter the following information, create your password and enjoy millions of redemption options</p>
                <form [formGroup]="registerForm" (ngSubmit)="register()">
                    <div class="item-row">
                        <div class="item-input">
                            <label for="">User information</label>
                            <input formControlName="name" type="text" placeholder="Name">

                            <div class="error"
                                *ngIf="registerForm.controls['name']?.errors?.required  && !registerForm.controls['name']?.pristine">
                                <span>
                                    The field is required
                                </span>
                            </div>
                            <div class="error"
                                *ngIf="registerForm.controls['name']?.errors?.pattern  && !registerForm.controls['name']?.pristine">
                                <span>
                                    The field does not accept special characters
                                </span>
                            </div>
                        </div>
                        <div class="item-input">
                            <input formControlName="lastName" type="text" placeholder="Last name">

                            <div class="error"
                                *ngIf="registerForm.controls['lastName']?.errors?.required  && !registerForm.controls['lastName']?.pristine">
                                <span>
                                    The field is required
                                </span>
                            </div>
                            <div class="error"
                                *ngIf="registerForm.controls['lastName']?.errors?.pattern  && !registerForm.controls['lastName']?.pristine">
                                <span>
                                    The field does not accept special characters
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="item-input">
                        <input formControlName="email" type="text" placeholder="E-mail">

                        <div class="error"
                            *ngIf="registerForm.controls['email']?.errors?.required && !registerForm.controls['email']?.pristine">
                            <span>
                                The field is required
                            </span>
                        </div>
                        <div class="error"
                            *ngIf="registerForm.controls['email']?.errors?.email && !registerForm.controls['email']?.pristine">
                            <span>
                                You must enter a valid email
                            </span>
                        </div>
                        <div class="error"
                            *ngIf="registerForm.controls['email']?.errors?.pattern && !registerForm.controls['email']?.pristine">
                            <span>
                                You must enter a valid email
                            </span>
                        </div>
                    </div>
                    <div class="item-row">
                        <div class="item-input pwd-one">
                            <label for="">
                                Create a secure password
                                <span class="icon-info">
                                    <!-- <span>Unsupported characters <br> " ' ^ ` ¡ ° ´, ç ñ ? ; ¿ ÷</span> -->
                                    <span innerHTML="{{messageMustContain}}"></span>
                                </span>
                            </label>
                            <span class="icon-view" [ngClass]="{ 'activeIcon': isShowPassword}"
                                (click)="showPassword()"></span>
                            <input formControlName="password" [type]="isShowPassword?'text':'password'"
                                placeholder="Password">

                            <div class="error"
                                *ngIf="registerForm.controls['password'].errors?.required  && !registerForm.controls['password'].pristine">
                                <span>The field is required</span>
                            </div>
                            <div class="error"
                                *ngIf="registerForm.controls['password'].errors?.pattern  && !registerForm.controls['password'].pristine">
                                <span>Please enter a valid password</span>
                            </div>
                        </div>
                        <div class="item-input pwd-two">
                            <span class="icon-view" [ngClass]="{ 'activeIcon': isShowConfirmPsw}"
                                (click)="showConfirmPsw()"></span>
                            <input formControlName="confirmPassword" [type]="isShowConfirmPsw?'text':'password'"
                                placeholder="Confirm password">

                            <div class="error"
                                *ngIf="registerForm.controls['confirmPassword'].errors?.required  && !registerForm.controls['confirmPassword'].pristine">
                                <span>The field is required</span>
                            </div>
                            <div class="error"
                                *ngIf="registerForm.controls['confirmPassword'].errors?.mustMatch  && !registerForm.controls['confirmPassword'].pristine">
                                <span>Password not match</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-row">
                        <div class="checkbox-wrapper-13">
                            <input id="c1-13" type="checkbox" formControlName="confirmCheck">
                            <!-- <label for="c1-13">Accept <a (click)="openTyC()">Terms and Conditions</a></label> -->
                            <label for="c1-13">Accept <a href="https://tc.milesblue.com/#/miles" target="_blank">Terms
                                    and Conditions</a></label>
                        </div>
                    </div>

                    <div class="g-recaptcha" data-sitekey="your_site_key"></div>
                    <button type="submit" [ngClass]="{'active': registerForm.valid}" [disabled]="registerForm?.invalid">
                        Continue
                        <img class="loader" src="./assets/img/gennius/spinner.gif" alt="" *ngIf="inProcess">
                    </button>
                </form>
            </div>
        </div>
    </section>

    <section class="register register--great" *ngIf="!showForm && isRegister">
        <div class="container">
            <div class="block-center">
                <h2>Great!</h2>
                <h3>You have a new account!</h3>
                <p>Now you can download the app, log in with your new password and enjoy all the benefits we have for
                    you.
                </p>
                <span>Download Miles app now!</span>
                <div class="stores">
                    <a (click)="openUrl('ios')">
                        <img src="./assets/img/gennius/app-store.webp" alt="">
                    </a>
                    <a (click)="openUrl('android')">
                        <img src="./assets/img/gennius/play-store.webp" alt="">
                    </a>
                </div>
            </div>
        </div>
    </section>
</div>